<template>
    <div class="form-group">
        <label :for="`${model.status.formId}_${name}`">{{label}}</label>
        <select class="form-control"
            :id="`${model.status.formId}_${name}`"
            :name="name"
            v-model="model.vals[name]"
            :disabled="model.status.disabled || disabled"
            :required="required"
        >
            <option v-for="keyvalue in options" :key="keyvalue[0]" :value="keyvalue[0]">{{keyvalue[1]}}</option>
        </select>
    </div>
</template>

<script>
export default {
    props:{
        name:String,
        label:String,
        model:Object,
        disabled:{
            type:Boolean,
            default:false,
        },
        options:Array,
        required:{
            type:Boolean,
            default:false
        },
    }
}
</script>

<style>

</style>
